module.exports = __webpack_public_path__ + "media/Audio15_c.0b4b3126.wav";